import RequestContainer from 'containers/Request/index'
import React from 'react'

const RequestPage = () => {
  return (
   <>
   <RequestContainer/>
   </>
  )
}

export default RequestPage